import { useQuery } from '@tanstack/react-query'
import { api } from '../services/api'
import { FileText, Users, BookOpen } from 'lucide-react'
import { useLanguageStore } from '../stores/languageStore'

export default function Dashboard() {
  const { currentLanguageCode } = useLanguageStore()

  const { data: languages } = useQuery({
    queryKey: ['languages'],
    queryFn: () => api.get('/languages').then((res) => res.data),
  })

  const currentLanguage = languages?.data?.find(
    (lang) => lang.code === currentLanguageCode
  )

  const { data: pages } = useQuery({
    queryKey: ['pages', currentLanguageCode],
    queryFn: () =>
      api
        .get('/pages', {
          params: { locale: currentLanguageCode || 'en' },
        })
        .then((res) => res.data),
  })

  const { data: posts } = useQuery({
    queryKey: ['posts', currentLanguageCode],
    queryFn: () =>
      api
        .get('/posts', {
          params: { locale: currentLanguageCode || 'en' },
        })
        .then((res) => res.data),
  })

  const { data: users } = useQuery({
    queryKey: ['users'],
    queryFn: () => api.get('/users').then((res) => res.data),
  })

  const localeName = currentLanguageCode?.toUpperCase() || ''

  const stats = [
    {
      name: `Total Pages (${localeName})`,
      value: pages?.data?.length || 0,
      icon: FileText,
    },
    {
      name: `Total Posts (${localeName})`,
      value: posts?.data?.length || 0,
      icon: BookOpen,
    },
    {
      name: 'Users',
      value: users?.meta?.total || 0,
      icon: Users,
    },
  ]

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Dashboard</h1>
        <p className="mt-1 text-sm text-gray-500">
          Welcome to Ginger CMS. Here's an overview of your content.
        </p>
      </div>

      {/* Stats Grid */}
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {stats.map((stat) => (
          <div
            key={stat.name}
            className="bg-white overflow-hidden shadow rounded-lg"
          >
            <div className="p-5">
              <div className="flex items-center">
                <div className="flex-shrink-0">
                  <stat.icon className="h-6 w-6 text-gray-400" />
                </div>
                <div className="ml-5 w-0 flex-1">
                  <dl>
                    <dt className="text-sm font-medium text-gray-500 truncate">
                      {stat.name}
                    </dt>
                    <dd className="flex items-baseline">
                      <div className="text-2xl font-semibold text-gray-900">
                        {stat.value}
                      </div>
                    </dd>
                  </dl>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Recent Activity */}
      <div className="bg-white shadow rounded-lg">
        <div className="px-4 py-5 sm:p-6">
          <h3 className="text-lg leading-6 font-medium text-gray-900">
            Recent Activity
          </h3>
          <div className="mt-5">
            <div className="text-sm text-gray-500">
              No recent activity to display.
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
